export default "__VITE_ASSET__ByL8Zsyu__"